// import something here
import Clipboard from 'v-clipboard';
// leave the export, even if you don't use it
export default ({ Vue }) => {
  // something to do
  Vue.use(Clipboard);
};



// WEBPACK FOOTER //
// ./src/plugins/clipboard.js